<template>
	
        <div class="lime-body">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb breadcrumb-separator-1">
                                <!--<li class="breadcrumb-item"><a href="#">Pages</a></li>-->
                                <li class="breadcrumb-item active" aria-current="page">Payment</li>
                            </ol>
                        </nav>
                        <div class="page-title">
                            <!-- <h3>Payment List</h3> -->
                            <!--<div class="search-create">
                            	<form class="form-inline search" id="search">
				                    <input class="form-control mr-sm-2" type="search" placeholder="Search Payment" aria-label="Search" />
				                </form>
                            </div>-->
                            
                        </div>
                        <div class="page-title">
                               <h3>Payments(Received)</h3>
                               <div class="search-create">
                    
                                     <input class="form-control mr-sm-2"  v-model="filter" @keydown="$event.stopImmediatePropagation()" type="text" placeholder="Search payments" aria-label="Search" />
                                </div>
                            </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="table-responsive">
                          <datatable :class="tblCls" :columns="columns" :filter="filter" :per-page="5" :data="paymentList"></datatable>   
                          <datatable-pager v-model="page" class="pagination"></datatable-pager>
                        </div>
                     </div>
                  </div>
            </div>
        </div>
    
</template>
<script>
  import axios from 'axios'
  export default {
    name: 'Payment',
    data () {
      return {
        tblCls: 'table',
        paymentList: [],
        columns: [
          {label: 'Transaction ID', field: 'id'},
          {label: 'Amount', field: 'amount'},
          {label: 'Escrow User Amount', field: 'escrowUser_amount'},
          {label: 'UserA Amount', field: 'userA_amount'},
          {label: 'UserB Amount', field: 'userB_amount'},
          {label: 'UserC Amount', field: 'userC_amount'},
          {label: 'Brand Name', field: 'user_name'},
          {label: 'Date', field: 'dateCreated'},
          {label: 'Method', field: 'payment_method'},
          {label: 'Status', field: 'status'},
          {label: 'Payment Type', field: 'pyament_type'}

        ],
        rows: this.paymentList,
        filter: '',
        page: 1
      }
    },
    methods: {
      getPayment () {
        var jwttoken = localStorage.getItem('jwt')
        axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getAllPayments', {
          headers: {
            'x-access-token': jwttoken
          }})
          .then(response => {
            this.payments = response.data.results
            for (var i in this.payments) {
              var obj = this.payments[i]
              this.paymentList.push({
                id: obj.transaction_id,
                amount: obj.amount,
                user_name: obj.user_name,
                dateCreated: obj.dateCreated,
                payment_method: obj.payment_method,
                status: obj.status,
                pyament_type: obj.pyament_type,
                escrowUser_amount: obj.escrowUser_amount,
                userA_amount: obj.userA_amount,
                userB_amount: obj.userB_amount,
                userC_amount: obj.userC_amount
              })
              console.log(this.paymentList)
            }
          })
          .catch((error) => {
            // this.errorMessage = response.data.errors
            console.log(error)
            this.isLoading = false
          })
      }
    },
    created () {
      this.getPayment()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Payment.vue